// Stable topic IDs are assigned explicitly in publications.bib.js.
// A publication can cover multiple subjects; format and subject are independent.
export const publicationTopics = [
  { id: 'identity', pt: 'Identidade digital', en: 'Digital identity' },
  { id: 'authentication', pt: 'Autenticação e federação', en: 'Authentication & federation' },
  { id: 'cryptography', pt: 'Criptografia aplicada', en: 'Applied cryptography' },
  { id: 'signatures', pt: 'Assinaturas e documentos digitais', en: 'Digital signatures & documents' },
  { id: 'networks', pt: 'Redes e virtualização', en: 'Networks & virtualization' },
  { id: 'agents', pt: 'IA e sistemas multiagentes', en: 'AI & multi-agent systems' },
  { id: 'environment', pt: 'Meio ambiente e geociências', en: 'Environment & geosciences' },
  { id: 'interaction', pt: 'Interação e educação', en: 'Interaction & education' },
  { id: 'automation', pt: 'Automação e hardware', en: 'Automation & hardware' },
];
